{
  "records.open_status": "Açık",
  "periods.open_boundary": "Açık uçlu",
  "routines.reminder_on": "Açık"
}
